export default __webpack_public_path__ + "static/media/enneperuhr_light.e1a61806.png";